import SolutionBenefitsI18n from "@/components/landing/shared/SolutionBenefitsI18n";
import { TrendingUp, Clock, Users, Award } from "lucide-react";
const VertriebBenefitsSection = () => <SolutionBenefitsI18n translationPrefix="vertriebSolution" icons={[TrendingUp, Clock, Users, Award]} />;
export default VertriebBenefitsSection;
